export default "__VITE_ASSET__Byp3x7dr__"